import { useParams } from "react-router-dom";
import PageLayout from "../../components/layout/PageLayout/PageLayout";
import FormProjectNew from "../../components/forms/FormProjectNew/FormProjectNew";
import Breadcrumbs from "../../components/layout/BreadCrumbs";
import {
  useFetchProjectQuery,
  useFetchSitesQuery,
} from "../../features/api/apiSlice";
import styles from "../PageProject/PageProject.module.scss";

const PageProjectEdit: React.FC = () => {
  const { id } = useParams<{ id: string }>();

  const { data: projectData, isFetching } = useFetchProjectQuery(Number(id), {
    skip: !id,
  });

  const { data: sitesData, isFetching: isFetchingSites } = useFetchSitesQuery();

  const isPageLoading = isFetching || isFetchingSites;

  return (
    <PageLayout pageContainerClassName={styles.root} isLoading={isPageLoading}>
      <Breadcrumbs
        pageName="project"
        projectId={projectData?.id}
        projectName={projectData?.name}
      />
      {isPageLoading && <h1>Loading..</h1>}
      {!!projectData && (
        <FormProjectNew
          sites={sitesData?.results}
          isEditMode
          project={projectData}
        />
      )}
    </PageLayout>
  );
};

export default PageProjectEdit;
